var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"goHistory"},on:{"click":_vm.getOtsUrl}},[_vm._v("跳转中")])])}
var staticRenderFns = []

export { render, staticRenderFns }